<template>
    <div class="person-area">
        <img src="@/assets/images/bg/bg_img_1@3x.jpg" alt="" />
        <div class="person-area-main">
            <div class="person-area-main-bg">
                <div class="person-img">
                    <img class="person-img-static" :src="store.indexData.level.icon" alt="" />
                    <canvas class="person-img-svga" ref="refPersonSvga"></canvas>
                </div>
                <!-- 悬浮的奖品 -->
                <div class="awrad-list">
                    <div class="awrad-item" v-for="(item, index) in store.indexData.level_reward_list" :key="index" :class="`awrad-item-${index}`" @click="onViewAward(item)">
                        <img :src="item.reward_show_img_url" alt="" />
                    </div>
                </div>
            </div>
            <p class="level-title qm-special-font">{{ store.indexData.level.name }}</p>
            <p class="level-tip">9.25-10.22 做任务、积灵力，突破解锁限定奖励</p>
            <div class="level-progress" :class="{ 'level-progress-max': store.indexData.isMaxLevel }">
                <div class="level-progress-bar" :style="{ width: `${levelPercent}%` }">
                    <div class="level-progress-bar-active progressbar-fire" v-show="levelPercent >= 50 && !store.indexData.isMaxLevel"></div>
                </div>
                <div class="level-progress-btn" @click="onUpgrade" v-if="!store.indexData.isMaxLevel">
                    <canvas class="level-progress-btn-svga" ref="refUpgradeBtnSvga"></canvas>
                    <transition name="fade">
                        <div class="level-progress-btn-static button-upgrade" v-if="!showUpgradeBtnSvga"></div>
                    </transition>
                </div>
            </div>
            <p class="level-exp">
                {{ store.indexData.user_info.nickname || '七猫书友' }}的灵力值：{{ store.indexData.spiritual_power_value.user_current_value }}<span v-if="!store.indexData.isMaxLevel">/{{ store.indexData.spiritual_power_value.level_value }}</span>
            </p>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { onMounted, ref, computed, getCurrentInstance } from 'vue';
import { useStoreCommon } from '@common/store/common';
import { useStore } from '../../store';
import { openLogin, jsbReportV3, jsbFlushBgConfig } from '@q-front-npm/jsbridge';
import { apiUpgrade } from '@/http/api';
import { useStorePreload } from '@/store/preload';
import { Player } from 'svga';
const instance = getCurrentInstance();
const storeCommon = useStoreCommon();
const store = useStore();
const emits = defineEmits(['refresh']);
let actionList: Record<string, any>[] = [];
let isUpgrading = false;

const saClick = (title: string) => {
    jsbReportV3('moon_btn_button_click', { btn_wenan: '突破', return_result: title, });
};
const onUpgrade = async() => {
    if (isUpgrading) {
        return;
    }
    if (!store.indexData.isLogin) {
        openLogin();
        return;
    }
    if (!store.indexData.canUpgrade) {
        instance!.proxy.$toast('灵力值不足，请前往任务获取');
        return;
    }
    isUpgrading = true;
    actionList = [];
    try {
        playerPersonSvga && playerPersonSvga.start();
        const res = await apiUpgrade();
        const { level_reward, } = res;
        actionList.push({ type: 'upgrade', data: level_reward, });
        animateEnd();
        emits('refresh');
        const { level_name, level_num, reward_id, } = level_reward;
        saClick(level_name);
        if (level_num === '3') {
            // 通知客户端更新阅读背景
            jsbFlushBgConfig([reward_id]);
        }
        // 兜底兼容
        if (!playerPersonSvga) {
            isUpgrading = false;
        }
    } catch (err) {
        console.log('-- onUpgrade error', err);
        isUpgrading = false;
    }
};

const onViewAward = (item: Record<string, any>) => {
    store.setPopStatus('viewAward', true);
    store.setPopData(item);
};

const levelPercent = computed(() => {
    const { user_current_value, level_value, } = store.indexData.spiritual_power_value;
    const percent = Math.floor((user_current_value / level_value) * 100);
    return percent > 100 ? 100 : percent;
});

// 动画完成， 显示弹窗
const animateEnd = () => {
    if (actionList.length < 2) {
        return;
    }
    const reward = actionList.find((item) => item.type === 'upgrade')?.data;
    store.setPopData(reward);
    store.setPopStatus('get', true);
    actionList = [];
    isUpgrading = false;
};

const refUpgradeBtnSvga = ref();
const showUpgradeBtnSvga = ref(false);
let playerUpgradeBtn: Player;
const initUpgradeBtnSvga = async() => {
    const svgaFile = store.svgaFiles['upgrade-btn'];
    if (!svgaFile) {
        return;
    }
    if (!refUpgradeBtnSvga.value) {
        setTimeout(() => {
            initUpgradeBtnSvga();
        }, 60);
        return;
    }
    playerUpgradeBtn = new Player(refUpgradeBtnSvga.value);
    await playerUpgradeBtn.mount(svgaFile);
    playerUpgradeBtn.config.isCacheFrames = true;
    playerUpgradeBtn.start();
    showUpgradeBtnSvga.value = true;
};

const refPersonSvga = ref();
let playerPersonSvga: Player;
const initPersonSvga = async() => {
    const svgaFile = store.svgaFiles['upgrade'];
    if (!svgaFile) {
        return;
    }
    if (!refPersonSvga.value) {
        setTimeout(() => {
            initPersonSvga();
        }, 60);
        return;
    }
    playerPersonSvga = new Player(refPersonSvga.value);
    await playerPersonSvga.mount(svgaFile);
    console.log(playerPersonSvga);
    playerPersonSvga.config.loop = 1;
    playerPersonSvga.onEnd = () => {
        actionList.push({ type: 'end', });
        animateEnd();
    };
};
const update = () => {
    console.log('-- update', store.indexData.canUpgrade, playerUpgradeBtn);
    if (!playerUpgradeBtn) {
        return;
    }
    if (!store.indexData.canUpgrade) {
        playerUpgradeBtn.pause();
        return;
    }
    playerUpgradeBtn.resume();
};
const initSvga = () => {
    initPersonSvga();
    initUpgradeBtnSvga();
};
defineExpose({
    initSvga,
    update,
});
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.person-area {
    width: 100%;
    height: 1334px;
    position: relative;

    &-main {
        position: absolute;
        top: 440px;
        left: 0;
        right: 0;
        bottom: 0;
        &-bg {
            position: relative;
            min-height: 728px;
        }
    }

    .person-img {
        &-svga {
            position: absolute;
            bottom: -100px;
            left: 0;
            width: 100%;
            height: 1068px;
            z-index: 2;
        }
    }
}
.level-title {
    margin-top: -10px;
    font-size: 50px;
    color: #fcfdfe;
    line-height: 52px;
    height: 52px;
    text-align: center;
}
.level-tip {
    margin-top: 2px;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.78);
    line-height: 26px;
    text-align: center;
    font-family: '黑体';
}
.level-progress {
    margin: 20px 114px 0 64px;
    background: rgba(159, 184, 236, 0.73);
    box-shadow: inset 0px 2px 4px 0px rgba(255, 255, 255, 0.38), inset 0px -2px 10px 0px rgba(255, 255, 255, 0.59);
    border-radius: 200px 0px 0px 200px;
    border: 1px solid rgba(232, 255, 248, 0.77);
    height: 20px;
    border-radius: 20px;
    position: relative;
    z-index: 7;
    &-max {
        margin-right: 64px;
    }
    &-bar {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        border-radius: 16px;
        background: linear-gradient(90deg, #00d4ff 0%, #f8b936 50%, #ffb830 100%);
        box-shadow: inset 0px 0px 10px -2px #ffffff;
        transition: width 0.3s;
        &-active {
            position: absolute;
            top: 50%;
            right: -10px;
            transform: translateY(-50%);
        }
    }

    &-btn {
        position: absolute;
        width: 146.6px;
        height: 146.6px;
        top: 50%;
        right: -94px;
        transform: translateY(-50%);

        &-svga {
            position: absolute;
            width: 146.6px;
            height: 146.6px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        &-static {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
        }
    }
}
.level-exp {
    font-size: 20px;
    color: #ffffff;
    line-height: 26px;
    margin: 6px 0 0 64px;
    font-family: '黑体';
}
.awrad-list {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 7;
    .awrad-item {
        position: absolute;
        animation: awardAnimate 1s linear infinite;
        &-0 {
            left: 22px;
            top: 222px;
            width: 176px;
            height: 216px;
            animation-duration: 4s;
        }
        &-1 {
            left: 186px;
            top: 106px;
            width: 124px;
            height: 154px;
            animation-duration: 3.8s;
        }
        &-2 {
            left: 472px;
            top: 198px;
            width: 116px;
            height: 144px;
            animation-duration: 3s;
            z-index: 3;
        }
        &-3 {
            left: 498px;
            top: 290px;
            width: 188px;
            height: 230px;
            animation-duration: 4s;
        }
        &-4 {
            left: 440px;
            top: 500px;
            width: 116px;
            height: 144px;
            animation-duration: 3.6s;
        }
        &-5 {
            left: 160px;
            top: 424px;
            width: 154px;
            height: 190px;
            animation-duration: 3.6s;
        }
    }
}

@keyframes awardAnimate {
    50% {
        transform: translateY(-8px);
    }
    100% {
        transform: translateY(0);
    }
}
</style>
